import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

const timeToHours = (timeStr) => {
    const [hh, mm, ss] = timeStr.split(':').map(Number);
    return hh + mm / 60 + ss / 3600;
};

const SingleColorProgress = ({ timeStr, targetHours = 40 }) => {
    const hours = timeToHours(timeStr);
    const value = (hours / targetHours) * 100;

    return (
        <Box sx={{ maxWidth: '400px', minWidth: '400px', }}>
            <Box sx={{ marginBottom: 1 }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#1A1F36', }}>Total of working hours this week</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
                <LinearProgress
                    variant="determinate"
                    value={value}
                    sx={{
                        height: 24,
                        borderRadius: '4px',
                        width: '100%',
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: '#0076FE',
                        },
                    }}
                />
                <Typography sx={{ fontSize: '18px', color: '#1A1F36', whiteSpace: 'nowrap', }}>{`${timeStr}`}</Typography>
            </Box>
        </Box>
    );
};

export default SingleColorProgress;
